import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";
import { PatchRelabelCaseQuantityChange } from "src/types/api/relabelCases/patchRelabelCaseQuantity";

const useUpdateRelabelCaseQuantity = (relabelCaseService: RelabelCaseService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateCaseProductQuantities, isPending: isUpdating } = useMutation({
    mutationFn: ({ caseId, changes }: { caseId: string; changes: PatchRelabelCaseQuantityChange[] }) =>
      relabelCaseService.updateCaseProductQuantities(caseId, changes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedRelabelCases() });
      queryClient.invalidateQueries({ queryKey: queryKeys.relabelCaseStats() });
      onSuccess?.();
    }
  });

  return { updateCaseProductQuantities, isUpdating };
};

export { useUpdateRelabelCaseQuantity };
